import {Component, Input, OnInit} from '@angular/core';
import {TestExecution} from '../../../data/models/execution/test-execution';

@Component({
  selector: 'app-test-execution-expired',
  templateUrl: './test-execution-expired.component.html',
  styleUrls: ['./test-execution-expired.component.css']
})
export class TestExecutionExpiredComponent implements OnInit {

  @Input() testExecution!: TestExecution;

  constructor() {
  }

  ngOnInit(): void {
  }

}
